module.exports = __webpack_public_path__ + "static/media/cswap-emblem-purple.d40a418a.svg";